exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cardBody-adafd857{padding-top:10px;display:flex;flex-flow:column}.empty-e1e2b523{padding:10px 20px}.milestoneRow-b06946cc{padding:10px 20px;display:flex;justify-content:space-between}.milestoneRow-b06946cc h3{margin-bottom:5px}.milestoneRow-b06946cc.hovered-9aeae6eb{background:#f5f5f5}.overview-d3208d6d{color:#757575}.completed-2539a2c5{color:#757575;display:flex}.actions-78a0aa0e{display:none;margin-left:30px;width:50px;justify-content:space-between;color:#616161}.actions-78a0aa0e.hovered-9aeae6eb{display:flex}.actions-78a0aa0e span{cursor:pointer}.milestoneCTA-4cd80d6f{display:flex;margin:20px}\n", ""]);

// Exports
exports.locals = {
	"cardBody": "cardBody-adafd857",
	"empty": "empty-e1e2b523",
	"milestoneRow": "milestoneRow-b06946cc",
	"hovered": "hovered-9aeae6eb",
	"overview": "overview-d3208d6d",
	"completed": "completed-2539a2c5",
	"actions": "actions-78a0aa0e",
	"milestoneCTA": "milestoneCTA-4cd80d6f"
};